import React, { useEffect, useState } from "react";

import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import { useDispatch } from "react-redux";
import {
  ad_Add_Notes_inCompany_Action,
  ad_Create_Notes_inCompany_Action,
  ad_Delete_Notes_inCompany_Action,
  ad_Get_Notes_Description_byNoteID_inCompany_Action,
  ad_GetAll_Notes_inCompany_Action,
  ad_Update_Notes_inCompany_Action,
} from "../../redux/dev_aditya_action";
import { useSearchParams } from "react-router-dom";
import { Box, Button, Grid, IconButton, TextField, Tooltip, Typography } from "@mui/material";
// icon
import CloseIcon from "@mui/icons-material/Close";
import UpdateIcon from '@mui/icons-material/Update';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from "@mui/icons-material/Add";
import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';
import HtmlEditorDX from "../../user/pages/create-request/HtmlEditor";
import CustomLoader from "../../components/CustomLoader";
import { toast } from "react-toastify";
import {
  sonamConfirmMessage,
  sonamConfirmMessage1,
} from "../../redux/api_helper";

const ClientNotes = ({ Notesopen, NoteshandleClose }) => {
  const [createNote, setCreateNote] = React.useState(false);
  const [comment, setComment] = useState("");
  const [editorText, setEditorText] = useState("");
  const [noteList, setNoteList] = useState([]);
  const [selectedNote, setSelectedNote] = useState({});
  const [loader, setLoader] = useState(false);
  const [noteValues, setNoteValues] = useState({
    NoteName: "",
    NoteColor: "",
  });

  const [searchParams] = useSearchParams();
  const originatorNo = searchParams.get("OrgNo");
  const folder = searchParams.get("folder");
  const dispatch = useDispatch();

  useEffect(() => {
    GetAllNotes();
  }, []);

  const handleRemoveLoader = () => {
    setTimeout(() => {
      setLoader(false);
    }, 2000);
  };

  const GetAllNotes = () => {
    dispatch(
      ad_GetAll_Notes_inCompany_Action(originatorNo, (res) => {
        if (res) {
          setNoteList(res);
          setSelectedNote(res[0]);
        } else {
          GetAllNotes();
        }
      })
    );
  };

  useEffect(() => {
    if (selectedNote) {
      console.log(selectedNote);
      setEditorText();
      let payload = {
        NoteId: selectedNote?.NoteId,
        OriginatorNo: originatorNo,
      };
      dispatch(
        ad_Get_Notes_Description_byNoteID_inCompany_Action(payload, (res) => {
          console.log(res, "======== Notes_Description_");
          setEditorText(atob(res));
        })
      );
    }
  }, [selectedNote]);

  const handleEditorChange = (value) => {
    // Create a temporary DOM element in React to extract plain text
    const parser = new DOMParser();
    const doc = parser.parseFromString(value, "text/html");

    const plainText = doc.body.textContent || "";

    setComment(plainText); // Save only the text
    setEditorText(value); // Save the raw HTML if needed
  };

  const handleEditNote = (note) => {
    console.log(note, "=======note");
    setNoteValues(note);
    handleCreateNotePopup();
  };

  const handleCreateNotePopup = (add) => {
    if (add === "ADD") {
      setNoteValues({
        NoteName: "",
        NoteColor: "",
      });
      setCreateNote(!createNote);
    } else {
      setCreateNote(!createNote);
    }
    console.log(add, "===>");
  };

  const handleDeleteNote = (note) => {
    let text = "Are you sure to delete this Note";
    dispatch(
      sonamConfirmMessage(text, (confirm) => {
        console.log(confirm, "============ confirm");

        if (confirm) {
          setLoader(true);
          let payload = {
            OriginatorNo: originatorNo,
            NoteId: note?.NoteId,
          };

          dispatch(
            ad_Delete_Notes_inCompany_Action(payload, (res) => {
              GetAllNotes();
              toast.success("Notes Deleted")
              handleRemoveLoader();
            })
          );
        }
      })
    );
  };

  const HandleCreateNote = () => {
    setLoader(true);
    console.log(noteValues, "====  noteValues");
    if (noteValues?.NoteId) {
      let payload = {
        ...noteValues,
        OriginatorNo: originatorNo,
      };

      dispatch(
        ad_Update_Notes_inCompany_Action(payload, (res) => {
          console.log(res, "======== ad_Create_Notes_inCompany_Action");
          GetAllNotes();
          setNoteValues({
            NoteName: "",
            NoteColor: "",
          });
          toast.success("Notes Created");
          handleCreateNotePopup();
          handleRemoveLoader();
        })
      );
    } else {
      let payload = {
        ...noteValues,
        OriginatorNo: originatorNo,
      };

      dispatch(
        ad_Create_Notes_inCompany_Action(payload, (res) => {
          console.log(res, "======== ad_Create_Notes_inCompany_Action");
          GetAllNotes();
          setNoteValues({
            NoteName: "",
            NoteColor: "",
          });
          toast.success("Notes Updated");

          handleCreateNotePopup();
          handleRemoveLoader();
        })
      );
    }
  };

  const SaveStickyNotes = () => {
    setLoader(true);
    let payload = {
      NoteId: selectedNote?.NoteId,
      Notes: btoa(editorText),
      OriginatorNo: originatorNo,
    };
    console.log(payload, "=========payload");
    dispatch(
      ad_Add_Notes_inCompany_Action(payload, (res) => {
        handleRemoveLoader();
      })
    );
  };
  const heightStyle = {
    height: "calc(100vh - 350px)",
    overflow: "auto",
    maxheight: "215px",
  };
  return (
    <div>
      {/* notes modal */}
      <Dialog
        open={Notesopen}
        onClose={NoteshandleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="custom-modal modal-lg"
        maxWidth="md"

        fullWidth
      >
        <Box className="d-flex align-items-center p-3 justify-content-between modal-head">
          <Box className="clearfix">
            <Typography className="font-16 semibold">
              Add Notes{" "}
              <span
                onClick={() => handleCreateNotePopup("ADD")}

              >
                <Tooltip title="Add Note" arrow placement="top" >
                  <IconButton>
                    <AddCircleIcon fontSize="medium" color="primary" />
                  </IconButton>
                </Tooltip>

              </span>
            </Typography>
          </Box>

          {/*  */}
          <Button onClick={NoteshandleClose} autoFocus>
            <CloseIcon />
          </Button>
        </Box>

        {loader ? (
          <CustomLoader />
        ) : (
          <DialogContent className="pb-0">
            <DialogContentText id="alert-dialog-description" className="">

              <Grid container spacing={2}>
                <Grid item xs={12} md={4}>
                  <Box
                    style={{
                      ...heightStyle,
                      maxHeight: "300px", // Adjust the height as needed
                      overflowY: "auto"
                    }}
                    className="d-flex flex-column gap-1"
                  >
                    {Array.isArray(noteList) &&
                      noteList.length > 0 &&
                      noteList.map((note, index) => (
                        <Box
                          key={index}
                          className={`note_Box p-1 d-flex justify-content-between alignment-items-center ${selectedNote?.NoteId === note?.NoteId ? "select_attachment" : ""
                            }`}
                          sx={{
                            colors: note.NoteColor,
                            borderLeft: `4px solid ${note.NoteColor}`,
                          }}
                          onClick={() => setSelectedNote(note)}
                        >
                          <span>{note?.NoteName}</span>
                          <Box className="d-flex alignment-items-center gap-2">
                            <span onClick={() => handleEditNote(note)}>
                              <Tooltip title="Edit Note" arrow placement="top">
                                <EditIcon fontSize="small" color="primary" />
                              </Tooltip>
                            </span>
                            <span onClick={() => handleDeleteNote(note)}>
                              <Tooltip title="Delete Note" arrow placement="top">
                                <DeleteIcon fontSize="small" color="error" />
                              </Tooltip>
                            </span>
                          </Box>
                        </Box>
                      ))}
                  </Box>
                </Grid>

                <Grid item xs={12} md={8}>
                  <Box
                    className="compose-editor"
                    style={{
                      maxHeight: "300px", // Adjust as needed
                      overflowY: "auto"
                    }}
                  >
                    <HtmlEditorDX
                      height={"265px"}
                      templateDataMarkup={editorText}
                      handleEditorChange={handleEditorChange}
                    />
                  </Box>
                </Grid>

              </Grid>



            </DialogContentText>


          </DialogContent>

        )}
        <DialogActions>
          <Button
            className="btn-blue"
            startIcon={<SaveIcon />}
            onClick={SaveStickyNotes}
          >
            Save Note
          </Button>
          <Button
            onClick={NoteshandleClose}
            className="btn-red"
            startIcon={<CloseIcon />}
            autoFocus
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>

      {/* create Note */}
      <Dialog
        open={createNote}
        onClose={handleCreateNotePopup}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="custom-modal "
        maxWidth="xs"
        fullWidth
      >
        <Box className="d-flex align-items-center p-3 justify-content-between modal-head">
          <Box className="clearfix">
            <Typography className="font-16 semibold">
              {noteValues?.NoteId ? "Update Note" : "Create Note"}
            </Typography>
          </Box>

          <Button onClick={handleCreateNotePopup} autoFocus>
            <CloseIcon />
          </Button>
        </Box>

        {loader ? (
          <CustomLoader />
        ) : (
          <DialogContentText
            id="alert-dialog-description"
            className="p-3"
          >
            <Box gap={2}>
              <TextField
                className="w-100 mb-3"
                id="outlined-basic"
                label="Notes Name"
                variant="outlined"
                size="small"
                value={noteValues?.NoteName}
                onChange={(e) =>
                  setNoteValues((prev) => ({
                    ...prev,
                    NoteName: e.target.value,
                  }))
                }
              />
              <input
                type="color"
                className="w-100 "
                value={noteValues?.NoteColor}
                onChange={(e) =>
                  setNoteValues((prev) => ({
                    ...prev,
                    NoteColor: e.target.value,
                  }))
                }
                style={{
                  border: "none",
                  width: "40px",
                  height: "40px",
                  cursor: "pointer",
                  background: "none",
                }}
              />
            </Box>
          </DialogContentText>
        )}

        <DialogActions>
          <Button
            className="btn-blue"
            startIcon={noteValues?.NoteId ? <EditIcon /> : <AddIcon />}
            onClick={HandleCreateNote}
          >
            {noteValues?.NoteId ? "Update Note" : "Add Note"}
          </Button>
          <Button
            onClick={handleCreateNotePopup}
            className="btn-red"
            startIcon={<CloseIcon />}
            autoFocus
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default ClientNotes;
